import React from 'react';
import PropTypes from 'prop-types';
import SingleDataContainer from 'containers/Data/SingleDataContainer';
import utils from 'helpers/utils';
import { Link } from 'react-router-dom';
import { fetchUserAccumulated } from 'store/actions/users/fetchUsers';
import Chip from 'components/ui/chip/Chip';
import theme from 'theme/theme';

const linkStyle = {
    textDecoration: 'none',
    color: theme.palette.black,
};

class UserField extends React.Component {
    render() {
        const {
            backgroundColor,
            display,
            record,
            source,
            style,
        } = this.props;

        if (utils.isEmpty(record)) {
            return null;
        }

        return (
            <span style={ style }>
                <SingleDataContainer
                    action={ fetchUserAccumulated }
                    id={ record[source] }
                    resource='users'
                >
                    { (renderProps) => {
                        const { data } = renderProps;

                        return (
                            <Chip backgroundColor={ backgroundColor } style={ Object.assign({}, style, { cursor: 'pointer' }) }>
                                <Link to={ `/users/${ record[source] }/show` } style={ linkStyle }>
                                    { data[display] || utils.fullName(data.first_name, data.last_name) }
                                </Link>
                            </Chip>
                        );
                    }}
                </SingleDataContainer>
            </span>
        );
    }
}

UserField.propTypes = {
    backgroundColor: PropTypes.string,
    display: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    style: PropTypes.object,
};

export default UserField;



// WEBPACK FOOTER //
// ./src/components/field/UserField.js